"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.PureCommentsView = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _lodash2 = _interopRequireDefault(require("lodash.isequal"));

var _lodash3 = _interopRequireDefault(require("lodash.throttle"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _reactIntl = require("react-intl");

var _selectors = require("../selectors");

var _annotations = require("../selectors/annotations");

var _ErrorBoundary = _interopRequireDefault(require("../components/ErrorBoundary"));

var _AppContext = require("../context/AppContext");

var CommentsActions = _interopRequireWildcard(require("../actions/comments"));

var ContextActions = _interopRequireWildcard(require("../actions/context"));

var _Root = _interopRequireDefault(require("../wrappers/Root"));

var _CommentListView = _interopRequireDefault(require("../components/CommentListView/CommentListView"));

var _Submit = _interopRequireDefault(require("../containers/Submit"));

var _Delete = _interopRequireDefault(require("../components/Delete"));

var _AssetEmptyState = _interopRequireDefault(require("../components/EmptyState/AssetEmptyState"));

var _CloseBar = _interopRequireDefault(require("../components/CloseBar"));

var _Divider = _interopRequireDefault(require("../components/Divider/Divider"));

var _Errors = _interopRequireDefault(require("../components/Errors/Errors"));

var _Footer = _interopRequireDefault(require("../components/Footer/Footer"));

var _ImageContext = _interopRequireDefault(require("../components/ImageContext"));

var _Loading = _interopRequireDefault(require("../components/CommentList/Loading"));

var _CommentsView = _interopRequireDefault(require("../style/CommentsView.scss"));

var _constants = require("../constants");

var _CallbackContext = _interopRequireDefault(require("../context/CallbackContext"));

var _useIngest = _interopRequireDefault(require("../hooks/useIngest"));

var _usePrevious = _interopRequireDefault(require("../hooks/usePrevious"));

var _NoReviewAccessEmptyState = _interopRequireDefault(require("../components/EmptyState/NoReviewAccessEmptyState"));

var _reducers = require("../reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * CommentsView component
 * @param {Object} props - props for component
 * @reactProps {object} [assetData = {}] - data related to the current asset
 * @reactProps {string} assetData.id - id of the current asset
 * @reactProps {string} assetData.nodeId - id of the node within the asset
 * @reactProps {string} assetData.ownerId - id of owner of the current asset
 * @reactProps {string} assetData.region - region of the current asset
 * @reactProps {object} [commentProposedForDelete = null] - comment object in the process of being deleted
 * @reactProps {array} [comments = []] - list of comment objects
 * @reactProps {function} commentsAddDirtyComment - action for adding a comment to the dirty state
 * @reactProps {boolean} [commentsReceived = false] - boolean indicating if comments have yet been received
 * @reactProps {function} commentsPost - action for posting a comment
 * @reactProps {object} dirtyComments - dirty comments mapped by artboard ID
 * @reactProps {object} [errors = null] - object describing current errors being shown in the comments module
 * @reactProps {object} [imsData = {}] - data related to the current user
 * @reactProps {string} imsData.id - id of the current user
 * @reactProps {string} imsData.token - token of the current user
 * @reactProps {function} commentsResolve - action for resolving a comment
 * @reactProps {boolean} showResolvedComments - boolean indicating if resolved or unresolved comments are shown
 * @reactProps {function} commentsToggleReply - action for toggling reply state of comments
 * @reactProps {function} commentsOpen - action for opening a resolved comment
 * @reactProps {string} reCaptchaSiteKey - key to use to initilize recaptcha
 * @reactProps {string} reCaptchaEnabeld - key to use to enable/disable recaptcha
 * @returns {ReactElement} markup
 */
var Comments = function Comments(props) {
  var assetData = props.assetData,
      backgroundModeEnabled = props.backgroundModeEnabled,
      cacheComments = props.cacheComments,
      commentCancelForDelete = props.commentCancelForDelete,
      commentConfirmForDelete = props.commentConfirmForDelete,
      commentProposedForDelete = props.commentProposedForDelete,
      commentsListMinimized = props.commentsListMinimized,
      compactLayout = props.compactLayout,
      contextSetCommentsListMinimized = props.contextSetCommentsListMinimized,
      contextSetGuestUserLoginToastInfo = props.contextSetGuestUserLoginToastInfo,
      disableCommentCreation = props.disableCommentCreation,
      environment = props.environment,
      errors = props.errors,
      focusedInputInfo = props.focusedInputInfo,
      filterComments = props.filterComments,
      globalComments = props.globalComments,
      globalCommentsMode = props.globalCommentsMode,
      globalCommentsToggle = props.globalCommentsToggle,
      globalCommentsUnmapped = props.globalCommentsUnmapped,
      guestUserLoginToastInfo = props.guestUserLoginToastInfo,
      hasAnnotationLocation = props.hasAnnotationLocation,
      hasNewComment = props.hasNewComment,
      hasReviewAccess = props.hasReviewAccess,
      imageCapture = props.imageCapture,
      imageContextData = props.imageContextData,
      imsData = props.imsData,
      isFetching = props.isFetching,
      isExternalLoading = props.isLoading,
      isFilterOn = props.isFilterOn,
      isMapping = props.isMapping,
      isOffline = props.isOffline,
      localeStringOverrides = props.localeStringOverrides,
      mentionsEnabled = props.mentionsEnabled,
      setUnmappedView = props.setUnmappedView,
      registeredSectionIds = props.registeredSectionIds,
      resetGuestUserSession = props.resetGuestUserSession,
      reviewType = props.reviewType,
      showResolvedComments = props.showResolvedComments,
      spectrumUIScale = props.spectrumUIScale,
      style = props.style,
      theme = props.theme,
      touchControls = props.touchControls,
      viewingUnmapped = props.viewingUnmapped; // force memoizing of comments, to be fixed with selector refactor.

  var selectorComments = (0, _reducers.useSelector)(function (state) {
    return (0, _selectors.getFilteredComments)(state, props);
  });
  var prevComments = (0, _usePrevious.default)(selectorComments) || [];
  var comments = (0, _lodash2.default)(prevComments, selectorComments) ? prevComments : selectorComments;
  var callbackContext = (0, _react.useContext)(_CallbackContext.default);
  var ccxIngest = (0, _useIngest.default)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasRenderError = _useState2[0],
      setHasRenderError = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      commentsCloseBtnClicked = _useState4[0],
      setCommentsCloseBtnClicked = _useState4[1];

  var _useState5 = (0, _react.useState)(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      mobileCommentsListHeight = _useState6[0],
      setMobileCommentsListHeight = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isDeleting = _useState8[0],
      setIsDeleting = _useState8[1];

  var throttledSetMobileCommentsListHeight = (0, _react.useCallback)(function () {
    return (0, _lodash3.default)(setMobileCommentsListHeight, 300, {
      leading: false
    });
  }, [setMobileCommentsListHeight]);
  var commentsListRef = (0, _react.useRef)();
  var onShare = callbackContext.onShare;
  var handleMobileCommentsListHeightChange = (0, _react.useCallback)(function () {
    var onMobileCommentsListHeightChange = callbackContext.onMobileCommentsListHeightChange;

    if (typeof onMobileCommentsListHeightChange === 'function') {
      var newMobileCommentsListHeight = commentsListRef.current && commentsListRef.current.clientHeight;

      if (mobileCommentsListHeight !== newMobileCommentsListHeight) {
        throttledSetMobileCommentsListHeight(newMobileCommentsListHeight);
        onMobileCommentsListHeightChange(newMobileCommentsListHeight);
      }
    }
  }, [callbackContext, mobileCommentsListHeight, throttledSetMobileCommentsListHeight]);
  var handleRenderError = (0, _react.useCallback)(function (error) {
    ccxIngest.fireEvent(ccxIngest.events.generalError(environment, error));
    setHasRenderError(true);
  }, [setHasRenderError, ccxIngest, environment]);
  var handleCommentsListClick = (0, _react.useCallback)(function () {
    if (compactLayout && commentsListMinimized) {
      contextSetCommentsListMinimized(false);
      ccxIngest.fireEvent(ccxIngest.events.maximizeComponent);
    }
  }, [ccxIngest, commentsListMinimized, compactLayout, contextSetCommentsListMinimized]);
  var handleCloseButtonClick = (0, _react.useCallback)(function (evt) {
    evt.stopPropagation();
    var onCloseButtonClick = callbackContext.onCloseButtonClick;

    if (typeof onCloseButtonClick === 'function' && (focusedInputInfo === undefined || focusedInputInfo[assetData.nodeId] === undefined)) {
      onCloseButtonClick(); // close comments component overlay through host application

      ccxIngest.fireEvent(ccxIngest.events.closeComponent);
      return;
    }

    if (commentsListMinimized) {
      contextSetCommentsListMinimized(false);
    }

    setCommentsCloseBtnClicked(!commentsCloseBtnClicked);
    var itemType = focusedInputInfo && focusedInputInfo[assetData.nodeId] && focusedInputInfo[assetData.nodeId].itemType;

    if (itemType) {
      ccxIngest.fireEvent(ccxIngest.events.closeItemByType(itemType));
    }
  }, [assetData.nodeId, ccxIngest, commentsCloseBtnClicked, commentsListMinimized, callbackContext, contextSetCommentsListMinimized, focusedInputInfo]);
  var handleToastClose = (0, _react.useCallback)(function () {
    return contextSetGuestUserLoginToastInfo();
  }, [contextSetGuestUserLoginToastInfo]);
  var handleOnShare = (0, _react.useCallback)(function () {
    onShare(reviewType);
    ccxIngest.fireEvent({
      event: {
        subcategory: 'navigation',
        subtype: reviewType === 'artifact' ? 'create-review' : 'share-link',
        type: 'click'
      }
    });
  }, [ccxIngest, onShare, reviewType]);
  (0, _react.useEffect)(function () {
    if (compactLayout) {
      handleMobileCommentsListHeightChange();
    }

    return function () {
      if (compactLayout) {
        var onMobileCommentsListHeightChange = callbackContext.onMobileCommentsListHeightChange;

        if (typeof onMobileCommentsListHeightChange === 'function') {
          onMobileCommentsListHeightChange(0);
        }
      }
    };
  }, [callbackContext, compactLayout, handleMobileCommentsListHeightChange]);
  var imageData = !hasAnnotationLocation || !imageContextData ? '' : imageContextData.base64Data;
  var submit;

  if (backgroundModeEnabled || hasRenderError) {
    return null;
  }

  if (!showResolvedComments && !disableCommentCreation) {
    submit = /*#__PURE__*/_react.default.createElement(_Submit.default, _extends({}, props, {
      isReadyToAnnotate: registeredSectionIds.length > 0,
      onHeightChange: handleMobileCommentsListHeightChange,
      commentsCloseBtnClicked: commentsCloseBtnClicked,
      cacheComments: cacheComments
    }));
  }

  var handleDelete = function handleDelete() {
    var parentCommentId = commentProposedForDelete.parentCommentId;
    var onLogin = callbackContext.onLogin;
    setIsDeleting(true);
    return commentConfirmForDelete(assetData.id, cacheComments).then(function () {
      ccxIngest.fireEvent({
        event: {
          context_guid: parentCommentId,
          subcategory: parentCommentId ? 'delete-reply' : 'delete-comment',
          subtype: 'fade-out',
          type: 'render'
        }
      });
      setIsDeleting(false);
    }).catch(function (error) {
      ccxIngest.fireEvent({
        event: {
          context_guid: parentCommentId,
          subcategory: parentCommentId ? 'delete-reply' : 'delete-comment',
          subtype: 'error',
          type: 'render',
          error_code: error.status,
          error_type: error.message,
          error_desc: 'comment-failed-to-delete'
        }
      });
      setIsDeleting(false);

      if (imsData.token.includes('AnonBearer') && error.status === 401) {
        resetGuestUserSession();
        onLogin(false);
      }
    });
  };

  var showCloseButton = Boolean(!commentsListMinimized || focusedInputInfo && focusedInputInfo[assetData.nodeId]);
  var newCommentInputFocused = (0, _lodash.default)(focusedInputInfo, "".concat(assetData.nodeId, ".itemType")) === 'root';
  var commentBody;

  if (!hasReviewAccess) {
    commentBody = /*#__PURE__*/_react.default.createElement(_NoReviewAccessEmptyState.default, null);
  } else if (assetData.isSaving) {
    commentBody = /*#__PURE__*/_react.default.createElement(_Loading.default, {
      testId: "saving"
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "comments.list.saving"
    }));
  } else if (assetData.id || isOffline) {
    commentBody = /*#__PURE__*/_react.default.createElement("div", {
      className: "flex-flow-wrapper"
    }, compactLayout && /*#__PURE__*/_react.default.createElement(_CloseBar.default, {
      onBarClick: handleCommentsListClick,
      onClick: handleCloseButtonClick,
      showCloseButton: showCloseButton
    }), /*#__PURE__*/_react.default.createElement(_Errors.default, null), submit, imageCapture && imageContextData && hasAnnotationLocation ? /*#__PURE__*/_react.default.createElement(_ImageContext.default, {
      imageData: imageData,
      width: 100,
      height: 100
    }) : '', /*#__PURE__*/_react.default.createElement(_CommentListView.default, {
      activeSectionInputFocused: Boolean((0, _lodash.default)(focusedInputInfo, "".concat(assetData.nodeId, ".id")))
      /* TODO: `commentsCloseBtnClicked` seems to toggle its value.
               It still works so leaving it as-is for now, but we should
               probably combine the following two into one or clean it up
               in another way. */
      ,
      closeButtonClicked: commentsCloseBtnClicked,
      commentListMinimized: commentsListMinimized || newCommentInputFocused,
      comments: comments
      /* TODO: Probably better to just pass a filter value directly to the list
               and have it handle it. We then could remove `isFiltered`. */
      ,
      filter: showResolvedComments ? 'resolved' : undefined,
      guestLoginToast: guestUserLoginToastInfo,
      hasError: errors && Boolean(errors.list),
      isFiltered: isFilterOn,
      isLoading: isFetching || isExternalLoading,
      imsData: imsData,
      mentionsEnabled: mentionsEnabled,
      onToastClose: handleToastClose
      /* TODO: `onHeightChange` is a compact layout specific callback
               that can be cleaned up when Item/TextareaInput are refactored. */
      ,
      onHeightChange: handleMobileCommentsListHeightChange,
      onShare: onShare ? handleOnShare : undefined,
      scrollToTop: hasNewComment,
      setCommentListMinimized: contextSetCommentsListMinimized,
      setUnmappedView: setUnmappedView,
      showAllScreenComments: globalCommentsMode,
      touchControls: touchControls,
      viewingUnmappedSection: viewingUnmapped
    }), /*#__PURE__*/_react.default.createElement(_Divider.default, null), /*#__PURE__*/_react.default.createElement(_Footer.default, {
      filterComments: filterComments,
      globalCommentsToggle: globalCommentsToggle,
      assetData: assetData,
      compactLayout: compactLayout,
      globalComments: globalComments,
      globalCommentsUnmapped: globalCommentsUnmapped,
      isMapping: isMapping,
      isOffline: isOffline
    }));
  } else {
    commentBody = /*#__PURE__*/_react.default.createElement(_AssetEmptyState.default, {
      onShare: onShare ? handleOnShare : undefined,
      reviewType: reviewType
    });
  }

  var commentsListWrapperClass = (0, _classnames.default)('comments-list-wrapper', {
    touch: touchControls,
    compact: compactLayout,
    'focused-input': compactLayout && focusedInputInfo && focusedInputInfo[assetData.nodeId] || commentsListMinimized
  });
  return /*#__PURE__*/_react.default.createElement(_ErrorBoundary.default, {
    onError: handleRenderError
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CommentsView.default.component, " ").concat(theme, "-theme ").concat(spectrumUIScale, "-scale"),
    id: _constants.FULL_COMPONENT_ID,
    style: style
  }, /*#__PURE__*/_react.default.createElement(_Root.default, {
    localeStringOverrides: localeStringOverrides
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: commentsListRef,
    className: commentsListWrapperClass
  }, commentBody, commentProposedForDelete && /*#__PURE__*/_react.default.createElement(_Delete.default, {
    commentProposedForDelete: commentProposedForDelete,
    isDeleting: isDeleting,
    onCancel: commentCancelForDelete,
    onDelete: handleDelete
  })))));
};

exports.PureCommentsView = Comments;
Comments.propTypes = {
  annotatingItmId: _propTypes.default.string,
  annotationsEnabled: _propTypes.default.bool,
  assetData: _propTypes.default.shape({
    id: _propTypes.default.string,
    isSaving: _propTypes.default.bool,
    nodeId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    ownerId: _propTypes.default.string,
    region: _propTypes.default.string
  }),
  backgroundModeEnabled: _propTypes.default.bool,
  cacheComments: _propTypes.default.bool,
  commentCancelForDelete: _propTypes.default.func,
  commentConfirmForDelete: _propTypes.default.func,
  commentsToggleReply: _propTypes.default.func,
  showResolvedComments: _propTypes.default.bool,
  commentProposedForDelete: _propTypes.default.object,
  comments: _propTypes.default.array,
  commentsGetting: _propTypes.default.bool,
  commentsReceived: _propTypes.default.bool,
  commentsPost: _propTypes.default.func.isRequired,
  commentsAddDirtyComment: _propTypes.default.func,
  commentsResolve: _propTypes.default.func,
  commentsOpen: _propTypes.default.func,
  contextSetCommentsListMinimized: _propTypes.default.func,
  contextSetGuestUserLoginToastInfo: _propTypes.default.func,
  disableCommentCreation: _propTypes.default.bool,
  filterComments: _propTypes.default.bool,
  globalComments: _propTypes.default.bool,
  globalCommentsMode: _propTypes.default.bool,
  globalCommentsUnmapped: _propTypes.default.bool.isRequired,
  globalCommentsToggle: _propTypes.default.shape({
    isActive: _propTypes.default.bool.isRequired,
    onToggle: _propTypes.default.func.isRequired
  }).isRequired,
  guestUserLoginToastInfo: _propTypes.default.object,
  hasAnnotationLocation: _propTypes.default.bool,
  hasNewComment: _propTypes.default.bool,
  hasReviewAccess: _propTypes.default.bool,
  isFilterOn: _propTypes.default.bool,
  mentionsEnabled: _propTypes.default.bool,
  localeStringOverrides: _propTypes.default.object,
  compactLayout: _propTypes.default.bool,
  commentsListMinimized: _propTypes.default.bool,
  setUnmappedView: _propTypes.default.func,
  errors: _propTypes.default.object,
  isFetching: _propTypes.default.bool,
  isMapping: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,
  isOffline: _propTypes.default.bool,
  imsData: _propTypes.default.shape({
    id: _propTypes.default.string,
    token: _propTypes.default.string
  }),
  reCaptchaSiteKey: _propTypes.default.string,
  reCaptchaEnabled: _propTypes.default.bool,
  registeredSectionIds: _propTypes.default.array,
  contextCreateGuestUserSession: _propTypes.default.func,
  style: _propTypes.default.object,
  imageCapture: _propTypes.default.bool,
  imageContextData: _propTypes.default.object,
  focusedInputInfo: _propTypes.default.object,
  environment: _propTypes.default.string,
  saveFocusedInputInfo: _propTypes.default.func,
  touchControls: _propTypes.default.bool,
  viewingUnmapped: _propTypes.default.bool,
  theme: _propTypes.default.oneOf(['light', 'lightest', 'dark', 'darkest']),
  spectrumUIScale: _propTypes.default.oneOf(['medium', 'large']),
  reviewType: _propTypes.default.oneOf(['artifact', 'cloudDoc']),
  resetGuestUserSession: _propTypes.default.func
};
Comments.defaultProps = {
  assetData: {},
  backgroundModeEnabled: false,
  commentProposedForDelete: null,
  comments: [],
  commentsReceived: false,
  errors: null,
  imsData: {},
  isFilterOn: false,
  isLoading: false,
  registeredSectionIds: [],
  reviewType: 'artifact',
  users: []
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _imsData$token;

  var backgroundModeEnabled = ownProps.backgroundModeEnabled,
      compactLayout = ownProps.compactLayout,
      globalComments = ownProps.globalComments,
      assetData = ownProps.assetData,
      annotationsEnabled = ownProps.annotationsEnabled,
      mentionsEnabled = ownProps.mentionsEnabled,
      imsData = ownProps.imsData,
      globalCommentsToggle = ownProps.globalCommentsToggle,
      filterComments = ownProps.filterComments;
  var filterTime = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.filterTime"));
  var filterUsers = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.filterUsers")); // force disable global commenting related controls in compact view

  var showResolvedComments = compactLayout ? false : (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.showResolvedComments"));
  var focusedInputInfo = compactLayout ? (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.focusedInputInfo")) : undefined;
  var isFilterOn = filterComments && (filterUsers.length > 0 || filterTime.length > 0 || showResolvedComments);
  var commentCounts = (0, _selectors.getCommentCounts)(state, ownProps);
  var hasUnmapped = !!(0, _lodash.default)(commentCounts, "allNodes.".concat(_constants.UNMAPPED_GLOBAL_ID));
  var multiPageAsset = assetData.validNodes && (assetData.validNodes.length > 1 || hasUnmapped);
  var globalCommentsMode = globalComments && multiPageAsset && globalCommentsToggle.isActive;
  return {
    annotatingItmId: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.annotatingItmId")),
    annotationColor: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.annotationColor")),
    annotationLocationNodeId: (0, _annotations.getAnnotationLocationNodeId)(state),
    annotationsEnabled: annotationsEnabled,
    assetData: assetData,
    backgroundModeEnabled: backgroundModeEnabled,
    clickedAnnotation: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.clickedAnnotation")),
    commentProposedForDelete: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.commentProposedForDelete")),
    commentsGetting: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.commentsGetting")),
    commentsListMinimized: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.commentsListMinimized")),
    commentsReceived: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.commentsReceived")),
    dirtyComments: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.dirtyComments")),
    errors: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.errors")),
    focusedInputInfo: focusedInputInfo,
    globalCommentsMode: globalCommentsMode,
    guestUserLoginToastInfo: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.guestUserLoginToastInfo")),
    hasAnnotationLocation: (0, _annotations.getHasAnnotationLocation)(state),
    hasNewComment: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.commentPosted")),
    isFetching: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.fetching")),
    isFilterOn: isFilterOn,
    isPlacingAnnotation: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.isPlacingAnnotation")),
    mentionsEnabled: mentionsEnabled && (imsData === null || imsData === void 0 ? void 0 : (_imsData$token = imsData.token) === null || _imsData$token === void 0 ? void 0 : _imsData$token.indexOf('AnonBearer')) === -1,
    newAnnotationType: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.newAnnotationType")),
    registeredSectionIds: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.registeredSectionIds")),
    showCommentId: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.showCommentId")),
    showResolvedComments: showResolvedComments,
    viewingUnmapped: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.viewingUnmapped"))
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    commentCancelForDelete: CommentsActions.commentCancelForDelete,
    commentConfirmForDelete: CommentsActions.commentConfirmForDelete,
    commentDeletePropose: CommentsActions.commentDeletePropose,
    commentsAddDirtyComment: CommentsActions.commentsAddDirtyComment,
    commentsEdit: CommentsActions.commentsEdit,
    commentsFilterClear: CommentsActions.commentsFilterClear,
    commentsOpen: CommentsActions.commentsOpen,
    commentsPost: CommentsActions.commentsPost,
    commentsResolve: CommentsActions.commentsResolve,
    commentsToggleReply: CommentsActions.commentsToggleReply,
    contextCreateGuestUserSession: ContextActions.contextCreateGuestUserSession,
    contextSetCommentsListMinimized: ContextActions.contextSetCommentsListMinimized,
    contextSetGuestUserLoginToastInfo: ContextActions.contextSetGuestUserLoginToastInfo,
    contextSetShowCommentId: ContextActions.contextSetShowCommentId,
    resetGuestUserSession: ContextActions.contextResetGuestUserSession,
    saveAnnotationColor: ContextActions.contextSaveAnnotationColor,
    saveAnnotationLocation: ContextActions.contextSaveAnnotationLocation,
    saveFocusedInputInfo: ContextActions.contextSaveFocusedInputInfo,
    setAnnotationMode: ContextActions.contextSetAnnotationMode,
    setClickedAnnotation: ContextActions.contextSetClickedAnnotation,
    setUnmappedView: ContextActions.contextSetUnmappedView
  }, dispatch);
};

exports.mapDispatchToProps = mapDispatchToProps;
var enhance = (0, _redux.compose)(_AppContext.withAppContext, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, undefined, {
  context: _reducers.reduxContext
}));

var _default = enhance(Comments);

exports.default = _default;